import { Card, CardContent } from "@/modern/components/ui/card";
import { Skeleton } from "@/modern/components/ui/skeleton";

export function WorkspaceBoardCardSkeleton() {
  return (
    <Card className="h-full border-border bg-card shadow-sm">
      <CardContent className="p-4 flex flex-col h-full">
        <div className="flex justify-between items-start mb-4">
          <div className="flex-1 min-w-0 space-y-4">
            <Skeleton className="h-5 w-3/4" />
            <div className="flex items-center gap-2">
              <Skeleton className="h-8 w-8 rounded-full" />
              <Skeleton className="h-4 w-28" />
            </div>
          </div>
          <Skeleton className="h-8 w-8 rounded-md shrink-0" />
        </div>

        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-4 w-6" />
          </div>
          <Skeleton className="h-5 w-24 rounded-full" />
        </div>

        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-3 w-2/3" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-3 w-2/3" />
          </div>
        </div>

        <Skeleton className="h-9 w-full rounded-md mt-auto" />
      </CardContent>
    </Card>
  );
}
